import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { Component, Input, OnInit } from '@angular/core';

import { CardContent, PageSectionContent } from '@types';
import { SectionComponent } from '../section-component.interface';
import { ResponsiveService, TitleTheme } from '@frk/eds-components';
import { CardsService } from '@services/cards.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'ft-media-cards-section',
  templateUrl: './media-cards-section.component.html',
  styleUrls: ['./media-cards-section.component.scss'],
})
export class MediaCardsSectionComponent implements SectionComponent, OnInit {
  /**
   * Bloomreach component
   */
  component: BrComponent;

  /**
   * Bloomreach page model
   */
  page: Page;

  /**
   * Page Section content
   */
  content: PageSectionContent;

  /**
   * Display type
   */
  sectionType: string;

  /**
   * Cards Array
   */
  cards: Array<CardContent>;

  /**
   * Number of Columns
   */
  columns = 3;

  theme: string;

  titleColorTheme: TitleTheme = 'basic';
  container = 'container';

  // if need to show four columns in a row
  @Input() showAllInRow = false;
  isHandheld$: Observable<boolean>;
  isMobile$: Observable<boolean>;

  /** Footnote for section block */
  footnote: string;
  statCardTheme: string;
  showCardGradient = false;
  constructor(
    private cardsService: CardsService,
    protected responsiveService: ResponsiveService
  ) {}

  ngOnInit(): void {
    this.isHandheld$ = this.responsiveService.isHandheld$();
    this.isMobile$ = this.responsiveService.isMobile$();
  }

  /**
   * Populate the component
   * @param component - A parameter
   * @param page - A parameter
   * @param content - A parameter
   */
  populate(
    component: BrComponent,
    page: Page,
    sectionType: string,
    content: PageSectionContent,
    theme: string,
    titleTheme: TitleTheme,
    container: string
  ) {
    this.component = component;
    this.page = page;
    this.sectionType = sectionType;
    this.content = content;
    this.titleColorTheme =
      this.component?.getParameters()?.titleColor || 'basic';
    if (
      sectionType === 'stats_cards' &&
      (theme === 'secondary-c' || theme === 'secondary-d')
    ) {
      this.titleColorTheme = 'white';
    }

    this.showAllInRow = component.getParameters()?.showAllInRow;
    if (this.content?.cards) {
      if (this.content.cards.length === 2) {
        this.columns = 2;
      }

      if (this.content.cards.length === 4 && this.showAllInRow) {
        this.columns = 4;
      } else if (this.content.cards.length === 4) {
        this.columns = 2;
      }

      if (this.content.cards.length >= 5) {
        this.columns = 3;
      }

      this.cards = this.cardsService.createCardGroups(
        this.content.cards as CardContent[],
        this.columns
      );
      this.cards = this.cardsService.formatCardURL(
        this.cards.flat(),
        this.page
      );

      this.theme = theme || 'primary';
      if (sectionType === 'key_cards') {
        this.addKeyCardSettings(theme);
      }

      this.container = container;
    }
    this.footnote = this.content.footnote?.value;
  }

  public setDownloadLocation(event) {
    this.cardsService.setDownloadLocation(event);
  }

  private addKeyCardSettings(theme: string): void {
    this.cards = this.cardsService.createCardGroups(
      this.cards as CardContent[],
      this.cards?.length % 2 === 0 && this.cards?.length !== 6 ? 2 : 3
    );

    if (theme === 'primary' || theme === 'secondary-a') {
      this.theme = 'dark';
    }

    if (theme === 'secondary-b' || theme === 'secondary-c') {
      this.theme = 'light';
    }

    if (theme === 'secondary-b' || theme === 'primary') {
      this.showCardGradient = true;
    }
  }
}
